document.addEventListener('DOMContentLoaded', function() {
  // CONFIGURATION
  const selector = '.product__description';
  const maxLines = 3; // Set how many lines you want to show initially

  document.querySelectorAll(selector).forEach(description => {
    // --- START: Robust Height Calculation ---
    const computedStyle = getComputedStyle(description);
    let lineHeight = parseFloat(computedStyle.lineHeight);

    // If lineHeight is not a number (i.e., it was "normal"), estimate it
    if (isNaN(lineHeight)) {
      const fontSize = parseFloat(computedStyle.fontSize);
      lineHeight = fontSize * 1.4; // A standard line height is ~140% of the font size
    }
    
    const maxHeight = maxLines * lineHeight;
    // --- END: Robust Height Calculation ---

    // Add a temporary attribute for easy debugging
    description.setAttribute('data-debug-heights', `scroll: ${description.scrollHeight}px, max: ${Math.round(maxHeight)}px`);

    // Check if the content actually needs to be collapsed
    if (description.scrollHeight > maxHeight) {
      description.classList.add('collapsible-description');
      description.style.setProperty('--line-clamp', maxLines);

      // Prevent button from being added more than once
      if (!description.nextElementSibling || !description.nextElementSibling.classList.contains('read-more-toggle')) {
        const button = document.createElement('button');
        button.innerText = 'Read More';
        button.className = 'read-more-toggle';
        description.parentNode.insertBefore(button, description.nextSibling);

        button.addEventListener('click', function() {
          description.classList.toggle('is-expanded');
          this.innerText = description.classList.contains('is-expanded') ? 'Read Less' : 'Read More';
        });
      }
    }
  });
});